import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import ServiceDetail from "../pages/services/detail/page";
import Calendar from "../pages/calendar/page";
import Sermons from "../pages/sermons/page";
import Resources from "../pages/resources/page";
import News from "../pages/news/page";
import Donate from "../pages/donate/page";
import Contact from "../pages/contact/page";
import BaptismForm from "../pages/resources/baptism-form/page";
import FuneralForm from "../pages/resources/funeral-form/page";
import EngagementForm from "../pages/resources/engagement-form/page";
import MarriageForm from "../pages/resources/marriage-form/page";
import MembershipForm from "../pages/resources/membership-form/page";
import EventBookingForm from "../pages/resources/event-booking-form/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/:id",
    element: <ServiceDetail />,
  },
  {
    path: "/calendar",
    element: <Calendar />,
  },
  {
    path: "/sermons",
    element: <Sermons />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/resources/baptism-form",
    element: <BaptismForm />,
  },
  {
    path: "/resources/engagement-form",
    element: <EngagementForm />,
  },
  {
    path: "/resources/marriage-form",
    element: <MarriageForm />,
  },
  {
    path: "/resources/funeral-form",
    element: <FuneralForm />,
  },
  {
    path: "/resources/membership-form",
    element: <MembershipForm />,
  },
  {
    path: "/resources/event-booking-form",
    element: <EventBookingForm />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/donate",
    element: <Donate />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
